// Shared sizing for the fullscreen "manage" dialogs (automations today;
// custom fields and other workspace-config surfaces converge here). One place
// to tune how wide they render — every manage dialog must read the same pair
// so they feel like one surface.
export const MANAGE_DIALOG_WIDTH = 1560;
export const MANAGE_DIALOG_MAX_WIDTH = "min(95vw, 100%)";

/**
 * The same surface as one className, for `DialogPopup`.
 *
 * `DialogPopup` is `max-w-lg` and renders its own Viewport, whose
 * `grid-rows-[1fr_auto_3fr]` is unreachable from a call site, so a
 * near-fullscreen surface states its own height and width and overrides the
 * stock cap. It insets 4rem a side; the 1560px cap is `MANAGE_DIALOG_WIDTH`.
 *
 * Mobile stays full-bleed under `bottomStickOnMobile`, whose viewport reserves
 * a 3rem top gap — one dialog covers both breakpoints, with no mobile fork.
 */
export const MANAGE_DIALOG_SURFACE =
  "h-[calc(100dvh-3rem)] w-full max-w-none sm:h-[calc(100dvh-4rem)] sm:w-[calc(100vw-4rem)] sm:max-w-[1560px]";
